export abstract class IAuthorizationService {
    abstract init();
    abstract fetchUserRoles(): any;
    abstract checkRetrievalStatus(): boolean;
    abstract isEntitled(roleExpression: string): boolean;
    abstract cleanUp(): void;
}
